var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Close = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ height: "24", width: "24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M24 2.433L14.433 12 24 21.567 21.567 24 12 14.433 2.433 24 0 21.567 9.567 12 0 2.433 2.433 0 12 9.567 21.567 0z", fill: color })));
};
Close.defaultProps = {
    color: '#333',
};
export default Close;
//# sourceMappingURL=Close.js.map